<template>
  <div class="align-items-center justify-content-center activityPopup cancel-activity-popup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="activity-button box" :class="[name]">
          <div class="info-window">
            <div class="header"></div>

            <div class="info-content">
              <p class="title">SCORE WORDT NIET BEWAARD</p>
              <p class="description">Als je de quiz afsluit worden je antwoorden en score niet bewaard. Indien je de
                quiz later opnieuw wil opstarten zul je opnieuw vanaf vraag 1 starten. Ben je zeker dat je de quiz wil
                afsluiten?</p>
            </div>
            <div class="footer"></div>

            <div class="button-row">
              <WhiteOutlineButton :buttonText="'NEE'" :stretch-to-fill="true"
                                  v-on:clicked="noClicked" style="min-width: 200px;"></WhiteOutlineButton>

              <WhiteOutlineButton :buttonText="'JA'" :stretch-to-fill="true"
                                  v-on:clicked="yesClicked" style="min-width: 200px;"></WhiteOutlineButton>
            </div>

          </div>

        </div>
      </transition>

    </div>
  </div>


</template>

<script>

import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";

export default {
  name: "LeaveActivityPopup",
  components: { WhiteOutlineButton },
  props: {
    name: String,
    open: Boolean,
    buddyId: Number,
  },

  data()
  {
    return {
      show: this.open,
    }
  },
  computed: {},
  mixins: [],
  methods: {

    noClicked()
    {
      this.$emit("closeClicked");
    },
    yesClicked()
    {
      this.$emit("confirmClicked");
    },

  },
  mounted()
  {

  },
  created()
  {
  },
}


</script>

<style lang="scss" scoped>

.activityPopup {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  top: 0;
  left: 0;
  display: flex;

  .popup-container {
    width: min(70vw, 70vh);
    min-width: 500px;
    height: min(70vw, 70vh);
  }

}

.activity-button {
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10%;
  position: relative;
}

.info-window {
  width: 100%;
  position: relative;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    height: min(5vw, 11vh);
    top: 1px;
    position: relative;
  }

  .info-content {
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px 50px;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    height: min(5vw, 11vh);
  }

}


.title {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  text-align: center;
}

.description {
  color: white;
}

.first {
  margin-bottom: 15px;
}

.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.button-row {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

</style>